import { useMatchMedia } from '@revolut-internal/ui-kit'
import { useLocalStorage } from 'react-use'

import { LocalStorageKeys } from 'lib/shared/consts'

export const useDarkMode = () => {
  const isColorSchemeDark = useMatchMedia('(prefers-color-scheme: dark)')
  const [isStorageDark, setStorageDark] = useLocalStorage<boolean>(
    LocalStorageKeys.DARK_MODE,
  )

  const isDarkMode = isStorageDark ?? isColorSchemeDark ?? false

  return {
    isDarkMode,
    toggle: () => setStorageDark(!isDarkMode),
  }
}
